import { h } from 'preact'
import Animate from 'rc-animate';

const $ = jQuery;

const speed = 600;

const animation = {
    updateHeight: function (node) {
        $(node).parent().addClass('animating');
        
        setTimeout(() => 
            $(node).parent().animate({
                height: $(node).outerHeight()
            }, speed, 'swing', () => {
                $(node).parent().removeClass('animating')
            })
        );
    },
    appear: function (node, done) {
        this.node = node;
        $(node).css('display', '')
        $(node).parent().css({
            height: $(node).outerHeight()
        });
        done();
    },
    stopIt: function (node) {
        $(node).stop(true).css('visibility', 'visible').parent().stop(true).removeClass('animating');
    },
    enter: function(node, done){
        this.updateHeight(node);
        $(node).css('display', '')
        this.node = node;
        $(node).css('visibility', 'visible').hide().fadeIn(600, done);
  
        return {
          stop:() => {
            this.stopIt(node);
            done();
          }
        };
    },
    leave: function(node, done){
      $(node).fadeOut(speed, done);
      return {
        stop:() => {
            this.stopIt(node);
            done();
        }
      };              
    }
  }

const componentProps = {class: 'trans-fade'}

export default ({ component: C, componentName: name, ...props}) =>
    <Animate animation={animation} component="div" componentProps={componentProps}>
        <div class="slide" key={name}>
            <C {...props} />
        </div>
    </Animate>


// WEBPACK FOOTER //
// ./js/components/TransitionFade.js